import { effectiveOccurrence } from "./eventDomain";
import { appearsCanceled, isDeclinedOnItsOwn } from "./occurrenceParticipation";
import { addDays, allDayDays } from "./eventTime";

// The ONLY place backend occurrence data is translated into FullCalendar's
// event-object shape. Everything upstream (fetching, RSVP, reminders, focus)
// works on plain occurrences; swapping the calendar renderer means replacing
// this file and the <FullCalendar> element in pages/Calendar.js.
//
// Domain identity lives in extendedProps — the FullCalendar `id` string is a
// render key only and should never be parsed back into an id.
//
// Rendered from the occurrence's effective values (overrides applied). An
// all-day occurrence is handed over as plain dates — its days in the event's
// timezone — so FullCalendar never shifts it by the browser's offset.
// Canceled occurrences stay on the grid, subdued and struck through; so does a
// date a series participant declined on its own (still "scheduled" — only
// drawn like a canceled one).
export function mapOccurrenceToCalendarEvent(occurrence) {
  const details = effectiveOccurrence({ occurrence });

  let start = occurrence.starts_at;
  let end = occurrence.ends_at;
  if (details.is_all_day) {
    const { firstDay, lastDay } = allDayDays(start, end, details.timezone);
    start = firstDay;
    end = addDays(lastDay, 1);
  }

  return {
    id: `occurrence-${occurrence.id}`,
    title: details.title,
    start,
    end,
    allDay: details.is_all_day,
    classNames: appearsCanceled(occurrence) ? ["blorp-event-canceled"] : [],
    extendedProps: {
      occurrenceId: occurrence.id,
      eventId: occurrence.event_id,
      occurrence,
      isCanceled: details.isCanceled,
      isDeclined: isDeclinedOnItsOwn(occurrence),
    },
  };
}
